import { Node } from "#/decision_tree_viewer/models/node";
import { useSnippetProcessor } from "#/decision_tree_viewer/composables/useSnippetProcessor";
import { stripHtml } from "#/shared/utils/string";

const { processText } = useSnippetProcessor();

export class SchedulingNoteNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "SchedulingNoteNode",

      title: undefined,
      message: undefined,
      noteText: undefined,

      targetNodeId: "continue",
    };
  }

  get currentState() {
    return { noteText: this.noteText };
  }

  get context() {
    return {
      [`scheduling-note-${this.id}`]: this.noteText,
    };
  }

  get possibleNextNodeIds() {
    return [this.targetNodeId];
  }

  beforeShow(context) {
    this.noteText = context[`scheduling-note-${this.id}`]?.noteText;
  }

  nextNodeId() {
    return this.targetNodeId;
  }

  reset() {
    this.noteText = undefined;
  }

  toSchedulingNote(context) {
    let noteTitle = stripHtml(processText(this.title, context)).trim();

    if (!noteTitle) {
      noteTitle = stripHtml(processText(this.message, context)).trim();
    }

    return `${noteTitle} ${this.noteText}`;
  }
}
